var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-dropdown-variations c-form__item" },
    [
      !_vm.disabled
        ? [
            _c("div", { on: { click: _vm.toggleDropdown } }, [
              _c("div", { staticClass: "c-rect-input" }, [
                _c("input", {
                  ref: "textvalue",
                  staticClass:
                    "c-rect-input__input c-dropdown-variations__value-field",
                  class: { "has-value": this.hasValue },
                  attrs: {
                    id: _vm.inputId,
                    type: _vm.type,
                    required: _vm.required ? "required" : false,
                    onkeydown: "event.preventDefault()"
                  },
                  domProps: {
                    value:
                      _vm.dataValue && _vm.dataValue.name
                        ? _vm.dataValue.name
                        : ""
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "c-rect-input__label",
                    attrs: {
                      for: _vm.inputId,
                      "data-required-suffix": this.requiredSuffix
                    }
                  },
                  [_vm._v(_vm._s(_vm.label))]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.showDropdown
              ? [
                  _c(
                    "div",
                    { staticClass: "c-dropdown-variations__content" },
                    [
                      _vm.filterable
                        ? _c(
                            "div",
                            { staticClass: "c-dropdown-variations__search" },
                            [
                              _c("input", {
                                ref: "search",
                                attrs: { placeholder: "Sök" },
                                on: {
                                  input: _vm.filterItems,
                                  keypress: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.selectFirstOnEnter($event)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("vue-icon", {
                                attrs: { name: "search", size: "c-icon--18px" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.resettable
                        ? _c(
                            "div",
                            {
                              staticClass: "c-dropdown-variations__item",
                              on: { click: _vm.reset }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(_vm.resetOptionText) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("collapse-transition", [
                        _c(
                          "ul",
                          {
                            ref: "dropdown",
                            staticClass: "c-dropdown-variations__list"
                          },
                          [
                            _vm._l(_vm.filteredItems, function(itemGroup) {
                              return [
                                _vm.itemGroups.length > 1 && itemGroup.label
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "c-dropdown-variations__item-group-label"
                                      },
                                      [_vm._v(_vm._s(itemGroup.label))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(itemGroup.items, function(item) {
                                  return _c(
                                    "li",
                                    {
                                      staticClass:
                                        "c-dropdown-variations__item",
                                      on: {
                                        click: function($event) {
                                          return _vm.chooseItem(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(item.name) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                })
                              ]
                            }),
                            _vm._v(" "),
                            _vm.allowCustomValue && this.$refs.search
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "c-dropdown-variations__item",
                                    on: {
                                      click: function($event) {
                                        return _vm.chooseItem({
                                          id:
                                            "övrigt:" + _vm.$refs.search.value,
                                          group: "Övrigt",
                                          name: _vm.$refs.search.value
                                        })
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "t-text-style-mu" },
                                      [_vm._v("Lägg till")]
                                    ),
                                    _vm._v(" " + _vm._s(_vm.$refs.search.value))
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    ],
                    1
                  )
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.disabled
        ? [
            _c("div", { staticClass: "c-rect-input" }, [
              _c("input", {
                ref: "textvalue",
                staticClass:
                  "c-rect-input__input c-dropdown-variations__value-field",
                class: { "has-value": this.hasValue },
                attrs: {
                  id: _vm.inputId,
                  type: _vm.type,
                  required: _vm.required ? "required" : false,
                  onkeydown: "event.preventDefault()",
                  disabled: "disabled"
                },
                domProps: {
                  value:
                    _vm.dataValue && _vm.dataValue.name
                      ? _vm.dataValue.name
                      : ""
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "c-rect-input__label",
                  attrs: { for: _vm.inputId }
                },
                [_vm._v(_vm._s(_vm.label))]
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }